export const isValidCurrencyInput = (value, { maxLength } = {}) => {
  if (value === "") {
    return true;
  }

  if (maxLength !== undefined && value.length > maxLength) {
    return false;
  }

  return /^\d+(\.\d{0,2})?$/.test(value);
};